import { ScrollbarPlugin } from 'smooth-scrollbar'
import { Data2d } from 'smooth-scrollbar/interfaces'

export class DisableScrollPlugin extends ScrollbarPlugin {
  static pluginName = 'disableScroll'

  static defaultOptions = {
    disableScrollX: true,
    disableScrollY: false,
  }

  transformDelta(delta: Data2d) {
    const newDelta = delta

    if (this.options.disableScrollX) {
      newDelta.x = 0
    }

    if (this.options.disableScrollY) {
      newDelta.y = 0
    }

    return newDelta
  }
}
